module.exports = function (fox) {
	var FormElementBase = require('./base')(fox);

	return fox.extend({
		__constructor: function () {
			this.params.womContainer = function () {
				return this.uploader.rwom1('#' + this.uploader.state);
			}.bind(this);

			this.super('__constructor', arguments);
					
			if (fox.wom.isSelector(this.params.uploader)) {
				this.uploader = this.formLayer.rwom1(this.params.uploader);
			} else if (fox.oop.instanceOf(this.params.uploader, 'Controller')){
				this.uploader = this.params.uploader;
			}

			if (!this.uploader)
				throw new Error('Uploader is missing for "' + this.key + '" field');

			this.uploader.addHook(function () {return false;}, 'onStartInitUpload');

			this.formLayer.handleEvent(this.uploader, 'switchState', function () {
				return this.init();
			}.bind(this), {
				prefix: ['watch', 'uploader', 'input', 'state'].join('_')
			});

			this.validateExistingImage = this.params.validateExistingImage || false;
		},

		init: function () {
			var previosValue = this.value;

			if (this.uploader.state === 'input') {
				this.super('init', arguments);
				this.registerEventCallbacks();

				this.value = null;

				if (this.disabled) {
					this.disable();
				}
				
				if (previosValue) {
					this.dispatchEvent('change', {value: null});
				}
			} else {
				if (this.womContainer.isEmbedded()) {
					this.nodes = this.womContainer.element;
				} else {
					this.womContainer.wait('addedToDom').then(function () {
						this.nodes = this.womContainer.element;
					}.bind(this));
				}
			}

			return this;
		},

		registerEventCallbacks: function () {
			var _this = this;

			if (!this.params.lazyUpload) {
				this.nodes.forEach(function (node) {
					_this.formLayer.addDomHandler({
						event: 'change',
						target: node,
						callback: _this.uploadFiles.bind(_this)
					});
				});
			}
		},

		setValue: function (value) {
			try {
				this.uploader.setValue(value);
			} catch (e) {
				fox.exception(e);
			}

			return this.super('setValue', arguments);
		},

		getValue: function (files) {
			if (!files && this.params.lazyUpload && this._getFiles()) {
				return this.uploadFiles();
			}

			return !files && this.value || this.uploadFiles();
		},

		uploadFiles: function () {
			var args = fox.clone(arguments);

			args[0] = this.nodes[0];

			if (this.uploader.state === 'progress' && this.inProgress) return this.inProgress;

			if (this._getFiles() && this.uploader.changeHandler.apply(this.uploader, args)) {
				this.inProgress = this.uploader.initUpload(this._getFiles()).then(function (resp) {
					delete this.inProgress;

					if (this.uploader.getOption('useOneApi')) {
						this.value = fox.objectGet(resp, 'params.answer.resource');
					} else {
						this.value = resp.map(function (oneResp) {
							return fox.objectGet(oneResp, 'params.answer.resource');
						});
					}

					this.dispatchEvent('change', {value: this.super('getValue', arguments)});

					return this.value;
				}.bind(this));

				return this.inProgress;
			}

			return false;
		},

		validate: function () {
			if (this.uploader.state !== 'input' && !this.validateExistingImage)
				return this._returnValidateResult(true);

			return this.super('validate', arguments);
		},

		_getFiles: function () {
			var node = this.nodes && this.nodes[0];

			return node && node.files && node.files.length && node.files || false;
		}
	}, FormElementBase, null, 'FormElementDomUploader');
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/newForm/elements/dom/uploader.js
// module id = 96
// module chunks = 0